import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { useMemberValidation } from '@hooks/useMemberValidation';

import { keysToCamel } from '@utils/butter';

import { IPageProps } from '@folx-types/flow-steps';

import MessagesStep, { IMessagesStepPageContent } from './MessagesStep.component';

interface IMessagesStepPageProps extends IPageProps {}

const MessagesStepPage: FC<IMessagesStepPageProps> = ({ path }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "messages-step" }) {
				page_header
				care_team_header
				care_team_subheader
				care_team_cta
				care_team_href
				care_team_description
				care_team_list
				support_header
				support_cta
				support_href
				support_subheader
				support_description
				support_list
				page_fineprint
			}
		}
	`);

	const { memberMetadata } = useMemberValidation();

	const refinedContent: IMessagesStepPageContent = keysToCamel(
		pageContent
	) as IMessagesStepPageContent;

	return (
		<MessagesStep
			pageContent={refinedContent}
			path={path}
			showCareTeamCard={!memberMetadata?.membership?.isMembershipInactive}
		/>
	);
};

export default MessagesStepPage;
